export const ImageDataSet = [
  {
    id: 1,
    frontImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/073b9402-bc44-4514-9841-79fe9bd23b1f.webp',
    backImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/0ce3ebda-98ef-4052-a6bd-d5a22753c141.webp',
    altFront: 'Front Image',
    altBack: 'Back Image',
    customClass: 'top-0 md:right-[-47px] lg:right-0',
  },
  {
    id: 2,
    frontImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/56d93b1b-5268-47da-808f-f2efe84cbf13.webp',
    backImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/3c8ea44a-256b-4dd2-b0b8-9ea58c99b6ea.webp',
    altFront: 'Front Image',
    altBack: 'Back Image',
    customClass: 'bottom-16 md:bottom-0 md:right-[-42px] lg:right-[46px]',
  },
  {
    id: 3,
    frontImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/3c8ea44a-256b-4dd2-b0b8-9ea58c99b6ea.webp',
    backImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/56d93b1b-5268-47da-808f-f2efe84cbf13.webp',
    altFront: 'Front Image',
    altBack: 'Back Image',
    customClass: 'top-16 md:left-[-48px] md:top-0 lg:top-0 lg:left-0 left-0',
  },
  {
    id: 4,
    frontImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/0ce3ebda-98ef-4052-a6bd-d5a22753c141.webp',
    backImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/073b9402-bc44-4514-9841-79fe9bd23b1f.webp',
    altFront: 'Front Image',
    altBack: 'Back Image',
    customClass: 'bottom-0 right-0 md:right-[126px]',
  },
]
export const staticImages = [
  {
    src: 'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/6c991308-7261-4bfb-8f7f-9021830da30e.webp',
    alt: 'Top Right Image',
    className:
      'flip-img flipimg-m w-[60px] h-[60px] absolute top-[96px] left-[-20px] md:top-16 md:left-0 lg:w-[160px] lg:h-[160px] object-cover',
  },
  {
    src: 'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/bcbb6e8b-94b5-4364-96e1-880f0035f192.webp',
    alt: 'Left Center Image',
    className:
      'flip-img absolute hidden md:block top-1/2 left-1/2 w-[180px] h-[180px] object-cover transform -translate-x-1/2 -translate-y-1/2',
  },
  {
    src: 'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/a10f4c45-c758-4853-ab6a-6c7c4765a4b4.webp',
    alt: 'Bottom Left Image',
    className:
      'flip-img flipimg-m absolute w-[52px] h-[52px] top-[65%] left-[-20px] md:top-[64%] lg:top-[62%] md:left-0 md:w-[120px] md:h-[120px] object-cover',
  },
  {
    src: 'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/c1963f99-62bd-46dc-bb1a-ec4f92fc035e.webp',
    alt: 'Top Right Image',
    className:
      'flip-img flipimg-m w-[60px] h-[60px] absolute top-40 lg:top-16 right-[-18px] md:top-16 md:right-0 lg:w-[160px] lg:h-[160px] object-cover',
  },
  {
    src: 'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/4b7318fb-e1b2-4873-8612-ce7dc3629dec.webp',
    alt: 'Right Center Image',
    className:
      'flip-img hidden md:block absolute top-1/2 left-1/2 w-[180px] h-[180px] object-cover transform -translate-x-1/2 -translate-y-1/2',
  },
  {
    src: 'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/e51543e6-f66c-4a11-b2ea-fabd0feccf53.webp',
    alt: 'Bottom Left Image',
    className:
      'flip-img flipimg-m absolute md:top-[64%] w-[52px] h-[52px] top-[76%] right-[-20px] md:right-0 md:w-[120px] md:h-[120px] object-cover',
  },
]